// extracted by mini-css-extract-plugin
module.exports = {"tickerDiv":"styles_tickerDiv__ORVeS","phrase":"styles_phrase__96Hux","tickerBanner":"styles_tickerBanner__1TBQj","tickerBadge":"styles_tickerBadge__rsLV6"};